import AuthService from './AuthService'
import ResultsService from './ResultsService'

export default class VoteService {
	constructor() {
		this.auth = new AuthService()
		this.ref = firebase.database().ref()
		this.votesRef = this.ref.child('votes')
		this.results = new ResultsService()
	}

	cast(pollId, option) {
		return this.auth.getOrCreateUser().then(({ uid }) => (
			this.get(pollId)
				.then((vote) => vote && vote.option)
				.then((existing) =>
					Promise.all([
						this.results.update(pollId, option, existing),
						this.votesRef.child(pollId).child(uid).set({
							option,
							ts: firebase.database.ServerValue.TIMESTAMP,
						}),
					])
				)
		))
	}

	get(pollId) {
		if (!this.auth.currentUser) {
			return Promise.resolve(null)
		}

		const { uid } = this.auth.currentUser

		return this.votesRef.child(pollId).child(uid).once('value')
			.then((snap) => snap.val())
	}
}



// WEBPACK FOOTER //
// ./src/services/VoteService.js